/**
 * Shared types for Form Funnel feature
 */

export const FORM_QUESTION_TYPE = [
  "text",
  "textarea",
  "number",
  "date",
  "email",
  "phone",
  "url",
  "select",
  "multiselect",
  "radio",
  "pictureChoice",
] as const;

export type FormQuestionType = (typeof FORM_QUESTION_TYPE)[number];

/**
 * Question types the public form funnel page (`/flows/[slug]`) can render.
 *
 * Single source of truth shared by the renderer and the Payload `form-questions`
 * collection: the CMS refuses to save a question whose type is missing here, so
 * content can no longer reference a type the page silently drops. `url` stays in
 * FORM_QUESTION_TYPE only because removing a select option needs a Postgres
 * enum migration; no question uses it.
 */
export const RENDERABLE_FORM_QUESTION_TYPE = [
  "text",
  "textarea",
  "number",
  "email",
  "phone",
  "date",
  "select",
  "radio",
  "pictureChoice",
  "multiselect",
] as const satisfies readonly FormQuestionType[];

export type RenderableFormQuestionType = (typeof RENDERABLE_FORM_QUESTION_TYPE)[number];

export const isRenderableFormQuestionType = (
  type: string | null | undefined
): type is RenderableFormQuestionType =>
  (RENDERABLE_FORM_QUESTION_TYPE as readonly string[]).includes(type ?? "");

/**
 * Canonical values for enrollment likelihood question
 */
export const ENROLL_LIKELIHOOD = {
  VERY_LIKELY: "VERY_LIKELY",
  SOMEWHAT_LIKELY: "SOMEWHAT_LIKELY",
  UNLIKELY: "UNLIKELY",
} as const;

export type EnrollLikelihood = (typeof ENROLL_LIKELIHOOD)[keyof typeof ENROLL_LIKELIHOOD];
